import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import Box from '../../styled/Box';

export const SignInWrapper = styled(Box)`
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), rgba(234, 244, 252, 0.7);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0 15px;
`

export const FormContainer = styled(Box)`
  box-shadow: 0px 30px 40px -6px rgba(23, 50, 142, 0.21);
  border: 1px solid rgba(23, 50, 142, 0.21);
  display: flex;
  flex-direction: row;
  justify-content: center;
  overflow: hidden;
  text-align: center;
  background: #fff;
  & h1, & h2{
    font-family: Open Sans, sans-serif!important;
  }
  & .leftBlock{
    backdrop-filter: blur(20px);
  }
`

export const Wrapper = styled.div`
  &.SigninWrapper {
    display: flex;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), rgba(234, 244, 252, 0.7);
  }

  &.SigninLeftBlock {
    width: 50%;
    min-height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
  }

  &.SigninRightBlock {
    width: 50%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.SigninRightInsideBlock {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;

    & .logoContainer{
      height: 38px;
      width: 38px;
      border-radius: 2px;
      background: #ffffff;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      & img {
        //height: 18px;
        width: 20px;
      }
    }
  }

  &.CombinedImages {
    position: relative;
    //min-height: calc(100% - 100px);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 8% 10px;
    text-align: center;
    max-width: 500px;
  }

  &.SignInLogo {
    margin-top: 20px;
    margin-left: 5%;
  }

  @media screen and (min-width: 1920px) {
    &.CombinedImages {
      margin: 0 10%;
    }
  }
  @media screen and (min-width: 2120px) {
    &.CombinedImages {
      margin: 0 20%;
    }
  }
`

/*export const Container = styled.div`
	&.SigninWrapper{
		display: flex;
		background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), rgba(234, 244, 252, 0.7);
	}
	&.SigninLeftBlock{
		width: 50%;
    min-height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
	}
	&.SigninRightBlock{
		width: 50%;
    min-height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	&.SigninRightInsideBlock{
		height: 100%;
		display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
	}
	&.CombainedImages{
		position: relative;
    min-height: calc(100% - 100px);
    display: flex;
    justify-content: center;
    align-items: center;
	}
	&.SignInLogo{
		margin-top: 20px;
		margin-left: 5%;
	}
	@media screen and (min-width: 1920px){
		&.CombainedImages{
			margin: 0 10%;
		}
	}
	@media screen and (min-width: 2120px){
    &.CombainedImages{
        margin: 0 20%;
    }
}
`;*/

export const StyledImg = styled.img`
  &.MansPhone {
    max-width: 100%;
    width: 100%;
  }
`;

export const H2Signin = styled.h1`
	font-family: Manrope, sans-serif;
	font-style: normal;
	font-weight: 800;
	font-size: 36px;
	line-height: 50px;
	text-align: center;
	color: #1c62ef;
  margin-bottom: 20px;
`;

export const Subheader = styled.p`
  font-weight: 400;
  font-size: 16px;
`

export const SigninBtn = styled(Button)`
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 15px;
	width: 290px;
	height: 40px;
	background: #fff;
	border-radius: 2px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 1px 16px 1px 1px;
	border-width: 0;
  margin-bottom: 10px;
	&:hover{
    background: #fff;
		//background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
		box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
	}
	&:focus{
		//background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
		box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
		border-width: 0;
	}
	&:not(:disabled):not(.disabled):active:focus{
		//background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
		box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
		border-width: 0;
	}
`;

export const MSigninBtn = styled(Button)`
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 15px;
  width: 100%;
  max-width: 360px;
  height: 40px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 24px;
  color: #5E5E5E;
  border: 1px solid #4F5388;
  box-sizing: border-box;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.084), 0px 1px 1px rgba(0, 0, 0, 0.168);
  border-radius: 40px;
  margin-bottom: 10px;
  &:hover{
    background: #fff;
    color: inherit;
    border: 1px solid #4F5388;
    box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
  }
  &:focus{
    color: inherit;
    background: #fff;
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    border: 1px solid #4F5388;
  }
  &:not(:disabled):not(.disabled):active:focus{
    color: inherit;
    background: #fff;
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    border: 1px solid #4F5388;
  }
`

export const H3Signin = styled.h3`
	font-family: OpenSans, sans-serif;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 164%;
	text-align: center;
	color: #2C2B48;
	max-width: 400px;
	padding: 24px 23.5px 22px 23.5px;
	margin-bottom: 40px;
	border-radius: 10px;
	background: rgb(250, 252, 255);
`;

export const StyledSpan = styled.span`
	width: 194px;
`;

export const Paragraph = styled.p`
	font-family: OpenSans, sans-serif;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 150%;
	text-align: center;
	color: #BABDBE;
  &.error{
    color: red;
  }
`;

export const StyledLink = styled(Link)`
	color: #0039BB;
  &:hover{
    text-decoration: none;
  }
`;